"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listenForMainMenuCharacterCustomizeUpdates = void 0;
const MainMenuCharacter_1 = require("../../../classes/MainMenuCharacter");
const pixel_pigeon_1 = require("pixel-pigeon");
const createMainMenuCharacterSelectState_1 = require("../../state/main-menu/createMainMenuCharacterSelectState");
const getMainMenuState_1 = require("../../state/main-menu/getMainMenuState");
const constants_1 = require("../../../constants");
const listenForMainMenuCharacterCustomizeUpdates = () => {
    (0, pixel_pigeon_1.listenToSocketioEvent)({
        event: "main-menu/character-customize/create-character",
        onMessage: (update) => {
            const mainMenuState = (0, getMainMenuState_1.getMainMenuState)();
            const mainMenuCharacterID = new MainMenuCharacter_1.MainMenuCharacter({
                classID: update.mainMenuCharacter.classID,
                clothesDyeItemID: update.mainMenuCharacter.clothesDyeItemID,
                figureID: update.mainMenuCharacter.figureID,
                hairDyeItemID: update.mainMenuCharacter.hairDyeItemID,
                id: update.mainMenuCharacter.characterID,
                level: update.mainMenuCharacter.level,
                maskItemID: update.mainMenuCharacter.maskItemID,
                outfitItemID: update.mainMenuCharacter.outfitItemID,
                skinColorID: update.mainMenuCharacter.skinColorID,
            }).id;
            const mainMenuCharacterIDs = [
                ...mainMenuState.values.mainMenuCharacterIDs,
                mainMenuCharacterID,
            ];
            mainMenuState.setValues({
                characterCustomizeState: null,
                characterSelectState: (0, createMainMenuCharacterSelectState_1.createMainMenuCharacterSelectState)({
                    page: Math.floor((mainMenuCharacterIDs.length - 1) / constants_1.mainMenuCharactersPerPage),
                }),
                mainMenuCharacterIDs,
            });
        },
    });
};
exports.listenForMainMenuCharacterCustomizeUpdates = listenForMainMenuCharacterCustomizeUpdates;
